// @flow

import { useCallback, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getIsDebugUnlocked } from '@alphaott/smart-tv-debug/selectors'
import { setDebugUnlocked } from '@alphaott/smart-tv-debug/actions'

const TAP_COUNT = 7
const TAP_WINDOW_MS = 3000

export const useDebugUnlock = (): boolean => useSelector(getIsDebugUnlocked)

export const useDebugUnlockGesture = (): (() => void) => {
  const dispatch = useDispatch()
  const tapsRef = useRef([])

  return useCallback(() => {
    const now = Date.now()
    tapsRef.current = [...tapsRef.current.filter((time) => now - time < TAP_WINDOW_MS), now]

    if (tapsRef.current.length >= TAP_COUNT) {
      tapsRef.current = []
      dispatch(setDebugUnlocked(true))
    }
  }, [dispatch])
}
